import React, { Component } from 'react'
import { Button, H1 } from "@blueprintjs/core"
import DateRangePicker from 'react-bootstrap-daterangepicker'
import moment from 'moment'
import _ from 'lodash'
import { RangeConfig } from '../../../config'
import axios from '../../../services/axios'
import storage from '../../../services/storage'

// COMPONENTES
import CommunicationStrategy from '../../SocialIntelligence/CommunicationStrategy/CommunicationStrategy'
import TotalActivity from '../../SocialIntelligence/TotalActivity/TotalActivity'
import Engagement from '../../SocialIntelligence/Engagement/Engagement'
import BestHashtags from '../../SocialIntelligence/BestHashtags/BestHashtags'
import BestDays from '../../SocialIntelligence/BestDays/BestDays'
import BestHours from '../../SocialIntelligence/BestHours/BestHours'
import TopicData from '../../SocialIntelligence/TopicData/TopicData'
import BestPosts from '../../SocialIntelligence/BestPosts/BestPosts'
import BestPaidPosts from '../../SocialIntelligence/BestPaidPosts/BestPaidPosts'


import 'bootstrap-daterangepicker/daterangepicker.css'
import './styles.css'

class MainContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      range: [
        moment(this.props.range[0]).startOf('day').toDate(),
        moment(this.props.range[1]).startOf('day').toDate()
      ],
      networks: this.props.networks,
      campaing: {
        campaign_id: 0
      },
      category: {
        category: {
          name: 'all'
        }
      }
    } 

    this.range = [
      moment(this.props.range[0]).startOf('day').toDate(),
      moment(this.props.range[1]).startOf('day').toDate()
    ]

    this.components = {}
    this.onSearch = this.onSearch.bind(this)
    this.onGetData = this.onGetData.bind(this)
    this.onChangeRange = this.onChangeRange.bind(this)
    this.onSelectCategory = this.onSelectCategory.bind(this)
    this.onSelectCampaing = this.onSelectCampaing.bind(this)
  }

  onSearch(){
    this.onGetData()
  }

  onGetData(){
    this.setState({
      range: this.range
    })
  }

  onChangeRange({startDate, endDate}){
    const range = [startDate.toDate(), endDate.toDate()]

    this.dateStart.innerHTML = moment(range[0]).format('YYYY-MM-DD')
    this.dateEnd.innerHTML = moment(range[1]).format('YYYY-MM-DD')

    storage.set('range', range)
    
    this.range = range
  }

  onSelectCategory(category){
    this.setState({
      category: category
    })
  }

  onSelectCampaing(campaing){
    this.setState({
      campaing: campaing
    })
  }

  render () {
    const exist = _.find(this.state.networks, {provider: this.props.filter})

    return(
      <div className="socialContainer" data-html2canvas-print>
        <div className="top-container">
          <div className="brands-added">
            <div className="grid">
              <div className="col-5_sm-12">
                <H1 className="brands-added__title">S|M|A|R|T ID</H1>
              </div>
              <div className="col-7_sm-12">
                <div className="searchContainer" data-html2canvas-ignore>
                  <div className="dateSmart bp3-dark">
                    <span className="searchCalendarIcon button-primary"><i className="far fa-calendar-alt"></i></span>
                    <DateRangePicker
                      {...RangeConfig} 
                      startDate={this.state.range[0]} 
                      endDate={this.state.range[1]}
                      onApply={(event, picker)=>(this.onChangeRange(picker))}>
                      <div className="daterangepickerDates">
                        <span className="daterangepickerDate" ref={(ref)=>(this.dateStart = ref)}>
                          {moment(this.state.range[0]).format('YYYY-MM-DD')}
                        </span>
                        <span className="daterangepickerDate" ref={(ref)=>(this.dateEnd = ref)}>
                          {moment(this.state.range[1]).format('YYYY-MM-DD')}
                        </span>
                      </div>
                    </DateRangePicker>
                    <Button onClick={this.onSearch} minimal="true" className="button button-primary">Search</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {(this.props.filter == 'all' || !!exist) ? (
          <div className="social-intelligence__container">
            <div className="grid" id="overview_organic">
              <H1 className="overview-section__title">
                FEED OVERVIEW {this.props.filter == 'all' ? '' : this.props.filter}
              </H1>
              <div className="col-12">
                <CommunicationStrategy 
                  onSelectCategory={this.onSelectCategory} 
                  filter={this.props.filter}
                  competitor={this.props.competitor}
                  range={this.state.range}
                  ref={(ref)=>( ref && (this.components['strategy'] = ref))}
                />
              </div>
              <div className="col-4_sm-12">
                <TotalActivity 
                  filter={this.props.filter}
                  competitor={this.props.competitor}
                  range={this.state.range}
                  ref={(ref)=>( ref && (this.components['activity'] = ref))}
                />
              </div>
              <div className="col-4_sm-12">
                <Engagement 
                  filter={this.props.filter}
                  competitor={this.props.competitor}
                  range={this.state.range}
                  ref={(ref)=>( ref && (this.components['Engagement'] = ref))}
                />
              </div>
              <div className="col-4_sm-12">
                <BestHashtags 
                  filter={this.props.filter}
                  competitor={this.props.competitor}
                  range={this.state.range}
                  ref={(ref)=>( ref && (this.components['bestHashtags'] = ref))}
                />
              </div>
              <div className="col-4_sm-12">
                <BestDays 
                  filter={this.props.filter}
                  competitor={this.props.competitor}
                  range={this.state.range}
                  ref={(ref)=>( ref && (this.components['bestDays'] = ref))}
                />
              </div>
              <div className="col-8_sm-12">
                <BestHours 
                  filter={this.props.filter}
                  competitor={this.props.competitor}
                  range={this.state.range}
                  ref={(ref)=>( ref && (this.components['bestHours'] = ref))}
                />
              </div>
              <div className="col-12">
                <TopicData 
                  filter={this.props.filter}
                  competitor={this.props.competitor}
                  range={this.state.range}
                  ref={(ref)=>( ref && (this.components['topicdata'] = ref))}
                />
              </div>
              <div className="col-12">
                <BestPosts 
                  filter={this.props.filter}
                  competitor={this.props.competitor}
                  range={this.state.range}
                  ref={(ref)=>( ref && (this.components['bestPosts'] = ref))}
                />
              </div>
              <div className="col-12">
                <BestPaidPosts 
                  filter={this.props.filter}
                  competitor={this.props.competitor}
                  range={this.state.range}
                  ref={(ref)=>( ref && (this.components['bestPaidPosts'] = ref))}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="notData">
            NO DATA
          </div>
        )}
      </div>
    )
  }
}

export default MainContainer



// WEBPACK FOOTER //
// ./src/components/Overview/MainContainer/MainContainer.js